"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var axsswitch_1 = require("./axsswitch");
var AXSToggle = /** @class */ (function (_super) {
    __extends(AXSToggle, _super);
    function AXSToggle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { enabled: _this.props.enabled };
        _this.toggle = function (value) {
            _this.setState(function (_a) {
                var enabled = _a.enabled;
                return ({ enabled: !enabled });
            }, function () { return _this.props.onChange(_this.state.enabled ? value : ''); });
        };
        return _this;
    }
    AXSToggle.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (this.props.enabled !== prevProps.enabled) {
            this.setState(function () { return ({ enabled: _this.props.enabled }); });
        }
    };
    AXSToggle.prototype.render = function () {
        var _this = this;
        return (React.createElement(axsswitch_1.AXSSwitch, __assign({ className: classnames_1.default(['c-axs-toggle', this.props.className]), enabled: this.state.enabled, onClick: function () {
                return _this.props.disabled ? null : _this.toggle(_this.props.value);
            }, disabled: this.props.disabled, label: this.props.label, labelBefore: this.props.labelBefore }, this.props)));
    };
    AXSToggle.defaultProps = {
        labelColor: 'axsui.forms.labelColor',
        toggleBorderColor: 'axsui.forms.toggleBorderColor',
        toggleBorderColorHover: 'axsui.forms.toggleBorderColorHover',
        toggleCheckBackgroundColor: 'axsui.forms.toggleCheckBackgroundColor',
        toggleCheckColor: 'axsui.forms.toggleCheckColor',
        type: 'check',
    };
    return AXSToggle;
}(React.Component));
exports.default = AXSToggle;
//# sourceMappingURL=index.js.map